<img
  src="./assets/images/signup/celebrate.svg"
  class="sm-h-[146px]"
  alt="people celebrating your signup"
  id="celebration-image"
/>

<h2 class="sm-text-xl sm-font-medium" i18n>Welcome to your new Dashpivot workspace!</h2>

<p class="sm-text-center sm-text-sm" i18n>
  You can switch between workspaces at anytime by clicking the ‘Switch workspace’ button in the navigation bar
  on the left.
</p>

<button
  type="button"
  data-test="close-button"
  (click)="close()"
  class="cc-btn-primary-constructive button-green sm-w-fit sm-p-2"
  i18n
>
  Get started
</button>
